// extracted by mini-css-extract-plugin
export default {"btn":"explorebtn_btn__uilaR","original":"explorebtn_original__PsxAV","letters":"explorebtn_letters__KkSOh"};